export default function currency(value, currencyCode) {
    if (value === null || typeof value === "undefined") {
        return '';
    }

    const currencySuffix = typeof currencyCode === "undefined" ? `` : ` ${currencyCode}`;

    return Number.parseFloat(value).toLocaleString('en-GB', { minimumFractionDigits: 2,
maximumFractionDigits: 2 }) + currencySuffix;
}
